import { buildCategoryUrl } from '@/lib/storefront/categoryUrl'

/**
 * Single canonical format for storefront navigation targets: a string path or absolute URL.
 * Accepts legacy smart-link objects { type, value? } / { kind, value? } and normalizes to string.
 */
export type LegacySmartLinkObject = {
  type?: string
  kind?: string
  value?: unknown
}

function isLegacySmartLinkObject(v: unknown): v is LegacySmartLinkObject {
  if (!v || typeof v !== 'object' || Array.isArray(v)) return false
  const o = v as Record<string, unknown>
  const t = o.type ?? o.kind
  return typeof t === 'string' && t.length > 0 && 'value' in o
}

/** Normalize any legacy / mixed input to a plain string suitable for storage and resolveNav. */
export function normalizeLink(value: unknown): string {
  if (value == null) return ''
  if (typeof value === 'string') return value.trim()
  if (typeof value === 'number' && Number.isFinite(value)) return String(value)
  if (!isLegacySmartLinkObject(value)) return ''

  const rawType = String(value.type ?? value.kind ?? 'custom').toLowerCase()
  const v = typeof value.value === 'string' ? value.value.trim() : ''

  switch (rawType) {
    case 'product':
      return v ? `/product/${v}` : ''
    case 'category':
      return buildCategoryUrl({ slug: v })
    case 'collection':
      return v ? `/collections/${v}` : ''
    case 'custom':
    default:
      return v
  }
}
